import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {ClientAgentContent} from "./agent/ClientAgentContent";
import {withRouterParams} from "../../utils/withRouterParams";

export class ClientAgent extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <ClientAgentContent
                    clientId={this.props.match.params.id}
                    sessionId={this.props.match.params.sessionId}
                />
            </div>
        )
    }
}

export default withRouterParams(ClientAgent);
